import * as WorkTimeTypeActions from 'app/core/store/actions/work-time-type.actions'
import { initialState } from '../states/work-time-type.states'


export type Action = WorkTimeTypeActions.All

export function reducer(state = initialState, action: Action) {
    switch (action.type) {
        case WorkTimeTypeActions.GET_LIST_OPTIONS_SUCCESS : {
            return {
                ...state,
                listOptions: action.payload
            }
        }
        default: return state
    }
}
